module.exports = __webpack_public_path__ + "static/fdav-ff132ba28d6eca8d4a0deaa3d9f629b9.png";